<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Notifications</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <b-button-toolbar key-nav aria-label="Notifications Toolbar">
            <b-button size="sm" variant="neutral" @click="getNotifications" v-if="selected.length == 0" class="mx-1" v-b-tooltip.hover title="Refresh"><i class="fas fa-rotate-right"></i></b-button>
            <b-button size="sm" variant="neutral" @click="deleteNotifications" v-if="selected.length > 0" class="mx-1" v-b-tooltip.hover title="Delete notifications"><i class="fas fa-trash"></i></b-button>
            <b-button size="sm" variant="neutral" @click="markAsUnread" v-if="selected.length > 0" class="mx-1"><i class="fas fa-envelope" v-b-tooltip.hover title="Mark as unread"></i></b-button>
            <b-button size="sm" variant="neutral" @click="markAsRead" v-if="selected.length > 0" class="mx-1"><i class="fas fa-envelope-open" v-b-tooltip.hover title="Mark as read"></i></b-button>
          </b-button-toolbar>
        </b-card-header>
        <b-table responsive small hover :items="notifications" :perPage="pagination.perPage" :currentPage="pagination.currentPage" :fields="fields" :filter="searchQuery" @row-clicked="goToNotification">
          <template #cell(action)="row">
            <b-form-checkbox :id="'checkbox-' + row.item.id" :name="'checkbox-' + row.item.id" @change="addSelected(row.item.id)" :checked="selected.includes(row.item.id)"></b-form-checkbox>
          </template>
          <template #cell(from)="row">
            {{ row.item.data.from }}
          </template>
          <template #cell(subject)="row">
            {{ row.item.data.subject }}
          </template>
          <template #cell(message)="row">
            {{ row.item.data.message }}
          </template>
          <template #cell(date)="row">
            {{ new Date(row.item.created_at) | date('M/d/Y') }}
          </template>
        </b-table>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import paginationMixin from '@/views/Components/Tables/PaginatedTables/paginationMixin';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [paginationMixin, errorsMixin],
  components: {
    RouteBreadCrumb
  },
  data() {
    return {
      notifications: [],
      fields: [
        {
          key: 'action',
          label: '',
          sortable: false
        },
        {
          key: 'from',
          sortable: true,
          tdClass: (value, index, item) => {
            if (item.read_at == null) {
              return 'unread'
            }
          }
        },
        {
          key: 'subject',
          sortable: true,
          tdClass: (value, index, item) => {
            if (item.read_at == null) {
              return 'unread'
            }
          }
        },
        {
          key: 'message',
          sortable: true,
          tdClass: (value, index, item) => {
            if (item.read_at == null) {
              return 'unread'
            }
          }
        },
        {
          key: 'date',
          sortable: true,
          tdClass: (value, index, item) => {
            if (item.read_at == null) {
              return 'unread'
            }
          }
        }
      ],
      selected: []
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    userSlug() {
      return this.$store.getters['profile/user'].slug;
    },
    notificationsCount() {
      return this.notifications.length;
    }
  },
  methods: {
    async getNotifications() {
      await axios.get(this.userRoute + "/notifications")
      .then(response => {
        this.notifications = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async markAsRead() {
      await axios.post(this.userRoute + "/notifications/mark-as-read", {
        notifications: this.selected
      })
      .then(response => {
        this.notifications = response.data;
        this.selected = [];
        this.$store.dispatch("notifications/get", { user: this.userSlug });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async markAsUnread() {
      await axios.post(this.userRoute + "/notifications/mark-as-unread", {
        notifications: this.selected
      })
      .then(response => {
        this.notifications = response.data;
        this.selected = [];
        this.$store.dispatch("notifications/get", { user: this.userSlug });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async deleteNotifications() {
      await axios.post(this.userRoute + "/notifications", {
        notifications: this.selected
      })
      .then(response => {
        this.notifications = response.data;
        this.selected = [];
        this.$store.dispatch("notifications/get", { user: this.userSlug });
      })
      .catch(error => {
        this.error(error);
      });
    },
    addSelected(notification) {
      if(this.selected.includes(notification)) {
        this.selected.splice(this.selected.indexOf(notification), 1);
      } else {
        this.selected.push(notification);
      }
    },
    goToNotification(record, index) {
      this.$router.push({
        path: "/notifications/" + record.id
      });
    },
  },
  created() {
    this.getNotifications();
  },
  mounted() {
    document.title = "Notifications | ClarityNOW";
  }
};
</script>
<style lang="scss">
.unread {
  font-weight: bold;
}
</style>